import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";

const TinyMceEditor = ({ value, getValue }) => {
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };
  return (
    <>
      <Editor
        apiKey={process.env.REACT_APP_TINY_MCE_KEY}
        init={{
          selectors: "textarea.tinymce",
          height: 300,
          plugins:
            "anchor autolink charmap codesample emoticons blocks image link lists media searchreplace table visualblocks wordcount linkchecker",
          toolbar:
            "undo redo | block sizeselect fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough link | image media table mergetags | numlist bullist | spellcheckdialog typography | align lineheight | indent outdent | emoticons charmap | removeformat",
          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          fontsize_formats: "8px 10px 12px 14px 16px 18px 20px 24px 36px",
          mergetags_list: [
            { value: "First.Name", title: "First Name" },
            { value: "Email", title: "Email" },
          ],
          min_height: 200,
        }}
        // init={{
        //   menubar: false,
        //   plugins: [
        //     "advlist",
        //     "autolink",
        //     "lists",
        //     "link",
        //     "image",
        //     "charmap",
        //     "preview",
        //     "anchor",
        //     "searchreplace",
        //     "visualblocks",
        //     "code",
        //     "fullscreen",
        //     "insertdatetime",
        //     "media",
        //     "table",
        //     "code",
        //     "help",
        //     "wordcount",
        //   ],
        //   toolbar:
        //     "undo redo | blocks | " +
        //     "bold italic forecolor | alignleft aligncenter " +
        //     "alignright alignjustify | bullist numlist outdent indent | " +
        //     "removeformat | help",
        //   content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        // }}
        onEditorChange={(newValue, editor) => {
          getValue(newValue);
        }}
        value={value}
      />
    </>
  );
};

export default TinyMceEditor;
